import { Link } from 'react-router-dom';
import type { HotItem } from '@/types/content';
import TrendBadge from '@/components/feature/TrendBadge';

const rankStyles: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-accent-500 text-primary-950',
  3: 'bg-secondary-500 text-background-50',
};

export default function RankingRow({ item, rank }: { item: HotItem; rank: number }) {
  const rankClass = rankStyles[rank] ?? 'bg-background-100 text-foreground-500';

  return (
    <article className="group flex gap-4 py-5">
      <div className="flex shrink-0 flex-col items-center gap-2">
        <span
          className={`flex h-9 w-9 items-center justify-center rounded-lg text-base font-bold tabular-nums ${rankClass}`}
        >
          {rank}
        </span>
        <span className="hidden font-heading text-sm tabular-nums text-foreground-400 sm:block">{item.heat}</span>
      </div>

      <Link to={`/article/${item.id}`} className="shrink-0">
        <div className="h-20 w-24 overflow-hidden rounded-lg sm:h-[86px] sm:w-32">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 瓜圈速报`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </Link>

      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
            {item.category}
          </span>
          <span className="text-[11px] text-foreground-400">{item.publishedAt}</span>
        </div>
        <h3 className="mt-1.5">
          <Link
            to={`/article/${item.id}`}
            className="text-[15px] font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base"
          >
            {item.title}
          </Link>
        </h3>
        <p className="mt-1.5 line-clamp-2 hidden text-sm leading-relaxed text-foreground-600 sm:block">
          {item.summary}
        </p>
        <div className="mt-2.5 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-fire-line text-primary-500" />
            <span className="font-medium text-foreground-700">{item.heat}</span>
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-chat-3-line" />
            {item.comments}
          </span>
          <TrendBadge trend={item.trend} value={item.trendValue} />
        </div>
      </div>
    </article>
  );
}